
function SimplePricingSection() {
    
    return (
      <>
        {/* <section class="simple-pricing-section" id="simple-pricing-section">
          <div class="row ">
            <div class="container">
              <div class="simple-pricing-wrap">
                <div class="title wow zoomIn">
                  <h2 class="white">
                    Simple <span class="red">Pricing</span>{" "}
                  </h2>
                </div>
                <div class="pricing-tables">
                  <div class="bar wow fadeInLeft">
                    <div class="pricing-table-box">
                      <div class="pricing-table-header">
                        <h3>4 Videos</h3>
                      </div>
                      <div class="pricing-table-content">
                        <h2>$1,500</h2>
                        <strong>/quarterly video</strong>
                      </div>
                      <div class="pricing-table-footer">
                        <p>Perfect for quarterly updates</p>
                      </div>
                      <div class="pricing-table-btn">
                        <a href="#" class="btn order-btn">
                          Get Started
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="bar wow zoomIn">
                    <div class="pricing-table-box">
                      <div class="pricing-table-header">
                        <h3>12 Videos</h3>
                      </div>
                      <div class="pricing-table-content">
                        <h2>$1,000</h2>
                        <strong>/monthly video</strong>
                      </div>
                      <div class="pricing-table-footer">
                        <p>33% Discount</p>
                      </div>
                      <div class="pricing-table-btn">
                        <a href="#" class="btn order-btn">
                          Get Started
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="bar wow fadeInRight">
                    <div class="pricing-table-box">
                      <div class="pricing-table-header">
                        <h3>24 Videos</h3>
                      </div>
                      <div class="pricing-table-content">
                        <h2>$750</h2>
                        <strong>/monthly video</strong>
                      </div>
                      <div class="pricing-table-footer">
                        <p>50% Discount</p>
                      </div>
                      <div class="pricing-table-btn">
                        <a href="#" class="btn order-btn">
                          Get Started
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section class="updated-simple-pricing-section" id="updated-simple-pricing-section">
          <div class="row ">
            <div class="container">
              <div class="updated-simple-pricing-wrap">
                <div class="title wow zoomIn">
                  <h2>Simple <span class="red">Pricing</span> </h2>
                </div>
                <div class="updated-pricing-tables">
                  <img src="./images/simple-price-bg-image.png" alt="simple price bg image" />
                    <div class="content-wrap">
                    <div clas="button">
                      <a href="#">Save 25% with annual billing,</a>
                    </div>
                    <h3>only $750 per video</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
}

export default SimplePricingSection